<script>
export default {
  name: "MoreButtons",
  props: {
    reverse: {
      type: Boolean,
      default: false,
    },
    showNum: {
      type: Number,
      default: 0,
    },
    trigger: {
      type: String,
      default: "click",
    },
  },
  methods: {
    renderMoreButton(list = [], appendDom) {
      return (
        <el-dropdown trigger={this.trigger}>
          <a class="btn flex items-center">
            更多操作
            <i class="el-icon-more ml-1"></i>
          </a>
          <el-dropdown-menu slot="dropdown">
            {list
              .filter((item) => item.tag)
              .map((item) => {
                // 转换为文本形式
                item.componentOptions.propsData.type = "text";
                return (
                  <el-dropdown-item
                    class={[
                      item.componentOptions.children[0] &&
                      item.componentOptions.children[0].text === ""
                        ? "hidden"
                        : "",
                    ]}
                  >
                    {[item]}
                  </el-dropdown-item>
                );
              })}
            {appendDom}
          </el-dropdown-menu>
        </el-dropdown>
      );
    },
  },
  render() {
    const buttonList = this.$slots.default || [];
    const appendDom = this.$slots.append || [];
    
    if (buttonList.length === 0 && !appendDom) {
      return <div></div>;
    }

    const baseButtons = buttonList.slice(0, this.showNum);
    const moreButtons = buttonList.slice(this.showNum);
    
    return (
      <div 
        class={["flex items-center whitespace-nowrap", this.reverse ? "is-reverse" : ""]}
        style="margin-left: 5px;"
      >
        {baseButtons.map((button, index) => (
          <span class="mr-2" key={index}>{button}</span>
        ))}
        {(moreButtons.length > 0 || appendDom) &&
          this.renderMoreButton(moreButtons, appendDom)}
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
/* 移除原有样式，改用内联样式和父组件控制 */
</style>